// import React, { useState, useEffect } from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Toast } from "../../../CustomComponent/toast";
// import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
// import performRequest from "../../../api/request";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// const CallTrackingChart = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [callData, setCallData] = useState();
//   const [loading, setLoading] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Default to current month
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year
//   const [selectedWeek, setSelectedWeek] = useState(1);

//   useEffect(() => {
//     setLoading(true);
//     performRequest(
//       "GET",
//       `/callTracking/getAllCallTrackingForCharts?week=${selectedWeek}&month=${selectedMonth}&year=${selectedYear}`
//     )
//       .then((res) => {
//         if (res.status === 200) {
//           setCallData({
//             month: res.data.month,
//             week: res.data.week,
//           });
//         } else {
//           Toast("error", "Error while getting data!");
//         }
//       })
//       .catch((err) => {
//         CustomErrorResponse(err);
//       })
//       .finally(() => setLoading(false));
//   }, [selectedWeek, selectedMonth, selectedYear]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Early return after hooks
//   if (!callData) return <div>Loading...</div>;

//   // Get unique usernames from all timeframes
//   const allUsersSet = new Set([
//     ...callData.month.map((u) => u.userName),
//     ...callData.week.map((u) => u.userName),
//   ]);
//   const userNames = Array.from(allUsersSet);

//   // Helper to map totalCount for each user in a given list
//   const getCounts = (list) =>
//     userNames.map(
//       (user) => list.find((entry) => entry.userName === user)?.totalCount || 0
//     );

//   // Chart data structure
//   const chartData = {
//     labels: userNames,
//     datasets: [
//       {
//         label: "Month",
//         data: getCounts(callData.month),
//         backgroundColor: "rgba(255, 99, 132, 0.6)",
//       },
//       {
//         label: "Week",
//         data: getCounts(callData.week),
//         backgroundColor: "rgba(54, 162, 235, 0.6)",
//       },
//     ],
//   };

//   // Chart options
//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "bottom",
//       },
//       tooltip: {
//         mode: "index",
//         intersect: false,
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//       },
//     },
//   };

//   const handleMonthChange = (event) => {
//     setSelectedMonth(event.target.value);
//   };

//   const handleYearChange = (event) => {
//     setSelectedYear(event.target.value);
//   };

//   const getMonthName = (monthIndex) => {
//     return new Date(0, monthIndex).toLocaleString("default", { month: "long" });
//   };
//   const handleWeekChange = (e) => {
//     setSelectedWeek(Number(e.target.value));
//   };

//   return (
//     <>
//       <div className="flex gap-2 mt-2 md:mt-0 mb-2">
//         {/* Year Selector */}
//         <select
//           className="border p-2 rounded"
//           value={selectedYear}
//           onChange={handleYearChange}
//         >
//           {Array.from({ length: 5 }, (_, index) => 2022 + index).map((year) => (
//             <option key={year} value={year}>
//               {year}
//             </option>
//           ))}
//         </select>

//         {/* Month Selector */}
//         <select
//           className="border p-2 rounded"
//           value={selectedMonth}
//           onChange={handleMonthChange}
//         >
//           {Array.from({ length: 12 }, (_, index) => (
//             <option key={index} value={index + 1}>
//               {getMonthName(index)}
//             </option>
//           ))}
//         </select>

//         {/* Week Selector */}
//         <select
//           className="border p-2 rounded"
//           value={selectedWeek}
//           onChange={handleWeekChange}
//         >
//           {[1, 2, 3, 4, 5].map((week) => (
//             <option key={week} value={week}>
//               Week {week}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="card p-4">
//       <h3>Call Tracking Overview</h3>
//         <Bar data={chartData} options={options} />
//       </div>
//     </>
//   );
// };

// export default CallTrackingChart;

import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import performRequest from "../../../api/request";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const CallTrackingChart = () => {
  const [callData, setCallData] = useState({ monthStats: [], weeklyStats: [] });
  const [loading, setLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      `/callTracking/getAllCallTrackingForCharts?month=${selectedMonth}&year=${selectedYear}`
    )
      .then((res) => {
        if (res.status === 200) {
          setCallData({
            monthStats: res.data.monthStats || [],
            weeklyStats: res.data.weeklyStats || [],
          });
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch(CustomErrorResponse)
      .finally(() => setLoading(false));
  }, [selectedMonth, selectedYear]);

  if (loading) return <div>Loading...</div>;

  const { monthStats, weeklyStats } = callData;

  // Collect all unique user names
  const allUsers = Array.from(
    new Set([
      ...monthStats.map((u) => u.userName),
      ...weeklyStats.flatMap((week) => Object.keys(week.userWiseCount || {})),
    ])
  );

  const getUserWeeklyCounts = (user) =>
    weeklyStats.map((week) => week.userWiseCount?.[user] || 0);

  const colors = [
    "rgba(122, 92, 17, 0.7)",
    "rgba(255, 206, 86, 0.7)",
    "rgba(75, 192, 192, 0.7)",
    "rgba(153, 102, 255, 0.7)",
    "rgba(255, 159, 64, 0.7)",
    "rgba(255, 99, 132, 0.7)",
  ];

  const chartData = {
    labels: allUsers,
    datasets: [
      {
        label: "Monthly Total",
        data: allUsers.map(
          (user) =>
            monthStats.find((entry) => entry.userName === user)?.totalCount || 0
        ),
        backgroundColor: "rgba(33, 150, 243, 0.6)",
      },
      ...weeklyStats.map((week, i) => ({
        label: week.weekLabel,
        data: allUsers.map((user) => week.userWiseCount?.[user] || 0),
        backgroundColor: colors[i % colors.length],
      })),
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const getMonthName = (monthIndex) =>
    new Date(0, monthIndex).toLocaleString("default", { month: "long" });

  const weekLabels = weeklyStats.map((week) => week.weekLabel);

  const getRandomColor = () => {
    const letters = "BCDEF";
    let color = "#";
    for (let i = 0; i < 8; i++) {
      color += letters[Math.floor(Math.random() * letters.length)];
    }
    return color;
  };

  // Generate colors for each week once
  // const weekColors = getRandomColor();

  // console.log('[cpolours are',weekColors);

  return (
    <>
      <div className="flex gap-2 mt-2 mb-4">
        <select
          className="border p-2 rounded"
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
        >
          {Array.from({ length: 5 }, (_, i) => 2022 + i).map((year) => (
            <option key={year}>{year}</option>
          ))}
        </select>

        <select
          className="border p-2 rounded"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(Number(e.target.value))}
        >
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {getMonthName(i)}
            </option>
          ))}
        </select>
      </div>

      <div className="card p-4">
        <h3 className="mb-2 font-semibold">
          Monthly vs Weekly Call Comparison
        </h3>
        <Bar data={chartData} options={chartOptions} />
      </div>
      <div className="card mt-5">
        <div className="table-responsive">
          <table className="table table-vcenter">
            <thead>
              <tr>
                <th className="p-3">
                  <span className="fs-2">Sr</span>
                </th>
                <th>
                  <span className="fs-2">Name</span>
                </th>
                <th>
                  <span className="fs-2">Monthly Total</span>
                </th>
                {weekLabels.map((label, index) => (
                  <th key={label}>
                    <span className="fs-2">{label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {monthStats.map(({ userName, totalCount }, index) => (
                <tr
                  key={userName}
                  style={{ backgroundColor: getRandomColor() }}
                >
                  <td>
                    <span className="fs-2">
                      <b>{index + 1}</b>
                    </span>
                  </td>
                  <td>
                    <span className="fs-2">
                      <b>{userName}</b>
                    </span>
                  </td>
                  <td>
                    <span className="fs-2">
                      {" "}
                      <b>{totalCount}</b>
                    </span>
                  </td>
                  {weeklyStats.map((week) => (
                    <td key={week.weekLabel}>
                      <span className="fs-2">
                        <b>
                          {" "}
                          {week.userWiseCount[userName] !== undefined
                            ? week.userWiseCount[userName]
                            : "-"}
                        </b>
                      </span>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CallTrackingChart;
